import Vue from 'vue'
import Router from 'vue-router'
import { Loading } from 'element-ui'
import Home from './views/Home.vue'
import { loginRegister } from './utils/routerLink'
import { isLogin } from 'service/login'
import { CODE_OK } from './utils/const'
import { isProduction } from './utils'
/* member page start */
import MemberEntry from './views/MemberEntry.vue' // entry
import MemberIndex from './views/MemberIndex/MemberIndex.vue' // index
import AccountAuth from './views/PersonalDetails/AccountAuth.vue' // 资料认证
import transfer from './views/transfer/transfer' // 内部转账
import TransferRecord from './views/transfer/TransferRecord.vue' // 内部转账记录
import deposit from './views/deposit/deposit' // 入金
import DepositRecord from './views/deposit/DepositRecord.vue' // 入金记录
import LiveMT4 from './views/LiveMT4/LiveMT4.vue' // LiveMT4账户
import DemoMt4 from './views/DemoMt4/DemoMt4.vue' // 模拟账户
import CreateLiveMT4 from './views/LiveMT4/CreateLiveMT4.vue' // 创建LiveMT4账户
import CreateDemoMt4 from './views/DemoMt4/CreateDemoMt4.vue' // 创建模拟账户
import Withdraw from './views/Withdraw/Withdraw.vue' // 出金
import WithdrawRecord from './views/Withdraw/WithdrawRecord.vue' // 出金记录
import EconomicCalendar from './views/EconomicCalendar/EconomicCalendar.vue' // EconomicCalendar
import SecuritySettings from './views/SecuritySettings/SecuritySettings.vue' // 重置密码

/* member page end */

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: {
        name: 'memberIndex'
      }
    },
    {
      path: '/main',
      name: 'sign',
      component: Home,
      children: [...loginRegister]
    },
    {
      path: '/main', // member-en entry all file
      name: 'member',
      component: MemberEntry,
      children: [
        {
          path: '/index',
          name: 'memberIndex',
          component: MemberIndex
        },
        {
          path: 'account-auth',
          name: 'AccountAuth',
          component: AccountAuth
        },
        {
          path: 'transfer',
          name: 'transfer',
          component: transfer
        },
        {
          path: 'transfer-record',
          name: 'TransferRecord',
          component: TransferRecord
        },
        {
          path: 'deposit',
          name: 'deposit',
          component: deposit
        },
        {
          path: 'deposit-record',
          name: 'DepositRecord',
          component: DepositRecord
        },
        {
          path: 'live-mt4',
          name: 'LiveMT4',
          component: LiveMT4
        },
        {
          path: 'demo-mt4',
          name: 'DemoMt4',
          component: DemoMt4
        },
        {
          path: 'live-mt4/create-live-mt4',
          name: 'CreateLiveMT4',
          component: CreateLiveMT4
        },
        {
          path: 'demo-mt4/create-demo-mt4',
          name: 'CreateDemoMt4',
          component: CreateDemoMt4
        },
        {
          path: 'withdrawal',
          name: 'Withdraw',
          component: Withdraw
        },
        {
          path: 'withdrawal-record',
          name: 'WithdrawRecord',
          component: WithdrawRecord
        },
        {
          path: 'economic-calendar',
          name: 'EconomicCalendar',
          component: EconomicCalendar
        },
        {
          path: 'security-settings',
          name: 'securitySettings',
          component: SecuritySettings
        }
      ]
    }
  ]
})

let loadingInstance
const no_limit_arr = [
  'memberIndex',
  'EconomicCalendar',
  'member',
  'DemoMt4',
  'AccountAuth',
  'login',
  'resetPassword',
  'resetPasswordSuccess',
  'verifyCodeGet',
  'verifyCodeLogin',
  'forgotPassword',
  'register',
  'CreateDemoMt4',
  'SecuritySettings',
  'PhoneCodeLogin'
]

const no_limit_sign = [
  'login',
  'resetPassword',
  'resetPasswordSuccess',
  'verifyCodeGet',
  'verifyCodeLogin',
  'forgotPassword',
  'register',
  'PhoneCodeLogin'
]

router.beforeEach(async (to, from, next) => {
  if (to.name !== 'login') {
    loadingInstance = Loading.service({
      fullscreen: true,
      customClass: 'mark-loading'
    })
  }

  if (!localStorage.uk_token && no_limit_sign.indexOf(to.name) === -1) {
    console.log(no_limit_sign.indexOf(to.name) !== -1)
    next({
      name: 'login'
    })
    return false
  }

  if (no_limit_arr.indexOf(to.name) !== -1) {
    next()
    return false
  }

  await window.vuex_store.dispatch('initInfo')
  if (!window.vuex_store.state.info.certification_status) {
    if (no_limit_arr.indexOf(to.name) === -1) {
      next({
        name: 'AccountAuth'
      })
      loadingInstance.close()
    } else {
      next()
    }
  } else {
    next()
  }
})

router.afterEach(route => {
  loadingInstance.close()
})

export default router